export const room = {
  groupName: {
    label: 'Groepsnaam',
    create: 'Verzin een groepsnaam',
  },
  name: {
    label: 'Naam',
    your: 'Jouw naam',
  },
  actions: {
    create: 'Maak kamer',
    scanCode: 'Scan deze kamercode',
    enter: 'Ga kamer binnen',
    start: 'Begin met de eerste kamer',
  },

  members: 'Groepsleden in de kamer',

  welcome: {
    part1: 'Welkom {{name}},',
    part2: 'wacht nog even tot het spel start',
  },

  instructions: {
    read: 'Lees nu in stilte de voorbeelden op je smartphone.',
    ready:
      'Als iedereen hiermee klaar is, kan je de kamer binnengaan. Leg jouw voorbeeld uit als het op het scherm verschijnt. Doe dit in je eigen woorden. Klik op de navigatieknoppen bovenaan het scherm om naar het volgende voorbeeld te gaan.',
    listen: 'Luister nu naar de anderen. Je groepsgenoten zijn aan de beurt.',
    continue:
      'We hebben alle voorbeelden gehad. Goed gedaan! Ga nu verder met de EDUbox.',
  },
  closed: 'De kamer is afgesloten',
};
